var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    width: "1em",
    height: "1em",
    preserveAspectRatio: "xMidYMid slice",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    x: 0,
    y: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_599)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6400231719017029,0,0,0.6400231719017029,35.70100021362305,36.67741394042969)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 1,
    d: " M0.8149999976158142,4.76200008392334 C0.8149999976158142,4.76200008392334 0.8149999976158142,-4.929999828338623 0.8149999976158142,-4.929999828338623 C0.8149999976158142,-4.929999828338623 -5.2179999351501465,-5.49399995803833 -9.244999885559082,-1.1749999523162842 C-13.272000312805176,3.1440000534057617 -13.517000198364258,11.817000389099121 -10.842000007629395,7.74399995803833 C-8.062000274658203,3.510999917984009 0.8149999976158142,4.76200008392334 0.8149999976158142,4.76200008392334z M13.51200008392334,0.34700000286102295 C13.51200008392334,0.34700000286102295 0.8149999976158142,-11.79699993133545 0.8149999976158142,-11.79699993133545 C0.8149999976158142,-11.79699993133545 0.8149999976158142,-4.953999996185303 0.8149999976158142,-4.953999996185303 C-9.777999877929688,-4.953999996185303 -11.656999588012695,2.3469998836517334 -12.576000213623047,7.0229997634887695 C-12.795999526977539,9.564000129699707 -11.71399974822998,9.385000228881836 -11.437000274658203,8.87600040435791 C-8.461000442504883,3.4140000343322754 0.8149999976158142,5.085000038146973 0.8149999976158142,5.085000038146973 C0.8149999976158142,5.085000038146973 0.8149999976158142,11.5649995803833 0.8149999976158142,11.5649995803833 C0.8149999976158142,11.5649995803833 13.51200008392334,0.34700000286102295 13.51200008392334,0.34700000286102295z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.4a6f58cfe1230f1d09ac30ffaa810776.svg";
export { ForwardRef as ReactComponent };